import React, { useState, useEffect } from "react";
import CaseInfo from "./CaseInfo/CaseInfo";
import CaseRecords from "./CaseRecords/CaseRecords";
import CaseDocuments from "./CaseDocuments/CaseDocuments";
import { getExpertCase } from "../../Services/CaseService";
import DicomStudies from "./DicomStudies/DicomStudies";
import { useLocation } from "react-router-dom";

const CaseDashboard = () => {
  const location = useLocation();
  const queryStr = location.pathname;
  const str = queryStr.split("/");
  const orderId = str[2];
  const [expertCaseInfo, setExpertCaseInfo] = useState();
  const [expertRecords, setExpertRecords] = useState([]);
  const [expertCaseDocuments, setExpertCaseDocuments] = useState([]);
  const [expertDicomStudies, setExpertDicomStudies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [displayDicomStudies, setDisplayDicomStudies] = useState(false);
  const [claimantName, setClaimantName] = useState('');
  const [isDownloadAllowed, setIsDownloadAllowed] = useState(true);
  const [isDownloadDicomAllowed, setIsDownloadDicomAllowed] = useState(false);
  const [showDicomCdDownload, setShowDicomCdDownload] = useState(false);

  useEffect(() => { 
    const getExpertCaseData = async () => {
      setIsLoading(true);
      try {
        const response = await getExpertCase(orderId);
        const expertCaseInfoObj = {
          orderNumber: response.data.orderNumber,
          claimantName: response.data.claimantName,
          claimNumber: response.data.claimNumber,
          firmFileNumber: response.data.firmFileNumber,
          hasChronologyFile: response.data.hasChronologyFile,
        };
        setIsDownloadAllowed(response.data.isDownloadAllowed);
        setIsDownloadDicomAllowed(response.data.isDownloadDicomAllowed);
        setClaimantName(response.data.claimantName);
        setExpertCaseInfo(expertCaseInfoObj);
        setExpertRecords(response.data.orderRecords);
        setExpertCaseDocuments(response.data.orderFiles);
        setExpertDicomStudies(response.data.orderDicoms);
        setShowDicomCdDownload(response.data.systemId === 1);

        if(response.data.orderDicoms?.length)
          setDisplayDicomStudies(true);

        setIsLoading(false);

      } catch (error) {
        setIsLoading(false);
        if (error.toString().includes("401")) {
          // Redirect to Un Authorized Page
        }
      }
    };

    getExpertCaseData();
  }, [orderId]);

  return (
    <div>
      <CaseInfo expertCaseInfoObj={expertCaseInfo} />
      {expertRecords && !!expertRecords.length && (
        <CaseRecords
          expertRecordsList={expertRecords}
          orderNumber={expertCaseInfo?.orderNumber}
          isLoading={isLoading}
          claimantName={claimantName}
          orderId={orderId}
          isDownloadAllowed={isDownloadAllowed}
          hasChronologyFile={expertCaseInfo?.hasChronologyFile}
        />)
      }
      {displayDicomStudies && (
        <DicomStudies
          studies={expertDicomStudies}
          orderId={orderId}
          isLoading={isLoading}
          isDownloadAllowed={isDownloadDicomAllowed}
          showDicomCdDownload={showDicomCdDownload}
        />)
      }
      {expertCaseDocuments && !!expertCaseDocuments.length && (
        <CaseDocuments
          expertCaseDocumentsList={expertCaseDocuments}
          orderId={orderId}
          isLoading={isLoading}
          isDownloadAllowed={isDownloadAllowed}
        />)
      }
    </div>
  );
};

export default CaseDashboard;
